import React from 'react';
import styled from 'styled-components';
import { AdditionalInfoFiles } from './additionalInfoFiles';

const Wrapper = styled.div`
    background: ${({ theme }) => theme.colors.gray1};
`;

const Content = styled.div`
    padding: 50px 20px;
    max-width: 1200px;
    margin: auto;
`;

const Html = styled.div``;

export const AdditionalInfo = ({ additionalInfo }) => {
    if (!additionalInfo) return null;

    const shouldRenderFiles =
        additionalInfo &&
        additionalInfo.frontmatter &&
        additionalInfo.frontmatter.files.length > 0;

    return (
        <Wrapper>
            <Content>
                {shouldRenderFiles && (
                    <AdditionalInfoFiles
                        files={additionalInfo.frontmatter.files}
                    />
                )}
                <Html
                    dangerouslySetInnerHTML={{ __html: additionalInfo.html }}
                />
            </Content>
        </Wrapper>
    );
};
